import { Box, Container, Typography, Divider, Link } from '@mui/material';
import { useI18n } from '../../utils/i18n';

/**
 * Page footer with contact email and copyright.
 * Divider at top, muted text colors, clean and compact.
 */
export default function FooterSection() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ pb: 4, pt: 2 }}>
      <Container maxWidth="lg">
        <Divider sx={{ mb: 4, borderColor: 'rgba(255,255,255,0.08)' }} />

        <Box sx={{ textAlign: 'center' }}>
          {/* Contact */}
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', mb: 1 }}
          >
            {t('landing.footer.contact')}:{' '}
            <Link
              href="mailto:soraneyamasaki@gmail.com"
              sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              soraneyamasaki@gmail.com
            </Link>
          </Typography>

          {/* Copyright */}
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', opacity: 0.7 }}
          >
            {t('landing.footer.copyright').replace('{year}', year)}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
